import './Countdown.css';
import { h } from 'preact';
import BaseComponent from '../BaseComponent';
import { timecode } from 'Services/Misc/format';

export default class Countdown extends BaseComponent {
  render(props) {
    if(props.media.duration > -2 && this.props.options.countdown) {
      return (
        <div class="countdown" data-can-skip={ props.media.canSkip && props.options.skip }>
          {
            `Ad ${timecode(props.media.duration - props.media.current_time)}`
          }
        </div>
      )
    }
      
    return null;
  }

  static supported({ configuration }) {
    return configuration.UI.countdown;
  }
}


// WEBPACK FOOTER //
// ./src/Display/Components/UpperControls/Countdown.js